module.exports = __webpack_public_path__ + "becefc8f361fd30769f3d2ae9a7b772b-pipelines_transmission_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/ugiPipelines/assets/pipelines_transmission_2x.jpg
// module id = 829
// module chunks = 0